<template>
  <form class="login-form absa-form" @submit.prevent="proceed" v-show="loaded">
    <div class="content-section">
      <absa-pay-logo />

      <h3 style="text-align: center;">Verify your Absa account</h3>
      <p>
        Enter your registered Absa account number to verify
      </p>
    </div>
    <div class="inputs-section">
      <!-- User Input -->
      <div class="input-block">
        <pf-input id="absa" v-model="accountNumber">
          <span>Absa Account Number</span>
        </pf-input>
        <div class="pay-button">
          <proceed-button
            :is-proceed-enable="canProceed()"
            :is-loading="this.isLoading"
          />
        </div>
      </div>
    </div>

    <div class="notification">
      <p class="note">
        <span><img src="../assets/images/info.svg" alt="info"/></span> Please
        note
      </p>
      <p class="disclaimer">
        Payfast by Network and Absa are enabling a safe and secure method of
        paying from your bank account. Payfast by Network will not access your
        bank account on your behalf.
      </p>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import { mapState } from 'vuex'
import PfCustomInput from '../components/CustomInput.vue'
import axios from '@/wrapper'
import loadingManager from '@/LoadingManager'
import AbsaPayLogo from '../components/AbsaPayLogo.vue'

export default {
  name: 'AbsaPayBankForm',
  mixins: [formMixin],
  components: {
    pfInput: PfCustomInput,
    AbsaPayLogo,
  },
  data() {
    return {
      loaded: false,
      accountNumber: '',
    }
  },
  async mounted() {
    this.loaded = true
  },
  computed: {
    ...mapState('transaction', ['transaction', 'capitecPayInputType']),
    ...mapState('signalRMessage', ['message']),
    isProceedEnable() {
      return this.canProceed()
    },
  },
  methods: {
    validateRegex() {
      return /^\d+$/.test(this.accountNumber)
    },
    canProceed() {
      return this.validateRegex()
    },
    async proceed() {
      if (!this.canProceed()) {
        return false
      }
      this.$emit('closeErrorMessage')
      let errorMessage = ''
      this.isLoading = true

      await axios
        .post('bankApi/absaPay/consent', {
          accountNumber: this.accountNumber,
          transactionId: this.transaction.id,
        })
        .then(response => {
          if (response.data.HasErrors) {
            errorMessage =
              response.data.ErrorMessages[0].ErrorMessage ?? errorMessage
          } else {
            this.message.instruction.message =
              'Please wait while we connect you to Absa'
            loadingManager.setLoading(true)
          }
        })
        .catch(err => {
          this.$handleException({ err, transactionId: this.transaction.id })
        })

      if (errorMessage !== '') {
        this.$emit('setError', errorMessage)
        this.isLoading = false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.absa-form {
  .notification {
    margin: 0 auto;
    text-align: center;
    border-radius: 8px;
    background: #d2cdcd4d;
    padding: 1px 20px;
    max-width: 320px;

    .note {
      font-weight: 700;
    }

    .disclaimer {
      font-size: 12px;
    }
  }

  .input__label span {
    font-size: 14px;
    font-weight: bold;
  }

  .content-section {
    h3 {
      text-align: center;
      font-weight: 700;
    }

    p {
      text-align: center;
      font-size: 14px;
    }
  }

  .pay-button {
    justify-content: center;
    min-width: 320px;
  }

  .input-block {
    align-items: center;
  }
}
</style>
